import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from '../components/layout/layout.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DismissalProcessReportsComponent } from './dismissal-process-reports/dismissal-process-reports.component';
import { AttendanceReportsComponent } from './attendance-reports/attendance-reports.component';
import { StudentsTrackingComponent } from './students-tracking/students-tracking.component';
import {StudentsDismissalTrackingLogComponent} from './students-dismissal-tracking/students-dismissal-tracking-log/students-dismissal-tracking-log.component'
import { AuthGuardService } from '../_services/auth-guard.service';

const routes: Routes = [
    {
        path: '', component: LayoutComponent,
        children: [
            {
                path: 'dashboard',
                component: DashboardComponent
            },
            {
                path: 'dismissal-reports',
                // canActivate: [AuthGuardService],
                component: DismissalProcessReportsComponent
            },
            {
                path: 'attendance-reports',
                component: AttendanceReportsComponent
            },
            {
                path: 'dismissal-tracking',
                // canActivate: [AuthGuardService],
                component: StudentsTrackingComponent
            },
            {
                path: 'dismissal-tracking-log/:type',
                // canActivate: [AuthGuardService],
                component: StudentsDismissalTrackingLogComponent
            },
            {
                path: '',
                redirectTo: '/reports/dashboard',
                pathMatch: 'full'
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class ReportsRoutingModule { }